<template>
  <div :class="['module-card', color]">
    <div class="module-card__header">
      <div class="module-card__icon-wrap">
        <i class="pi pi-users"></i>
      </div>
      <h3 class="module-card__title">{{ grade.name }}</h3>
    </div>

    <div class="module-card__body">
      <router-link :to="gradeRoute(grade, 'students')" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-table"></i>
        <span>جدول الطلاب</span>
      </router-link>
      <router-link :to="gradeRoute(grade, 'add')" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-user-plus"></i>
        <span>إضافة طالب</span>
      </router-link>
      <!-- <router-link :to="gradeRoute(grade, 'absence')" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-credit-card"></i>
        <span>شيت الدفع</span>
      </router-link> -->
      <!-- Original destination: gradeRoute(grade, 'payments') -->
      <router-link to="/coming-soon" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-wallet"></i>
        <span>المدفوعات</span>
      </router-link>
      <!-- Original destination: gradeRoute(grade, 'groups') -->
      <router-link to="/coming-soon" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-th-large"></i>
        <span>مجموعات الطلاب</span>
      </router-link>
      <!-- Original destination: gradeRoute(grade, 'attendance') -->
      <router-link to="/coming-soon" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-calendar"></i>
        <span>الغياب</span>
      </router-link>
      <router-link :to="gradeRoute(grade, 'branch')" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-sitemap"></i>
        <span>الفروع</span>
      </router-link>
      <router-link :to="gradeRoute(grade, 'unit')" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-book"></i>
        <span>الوحدات</span>
      </router-link>
      <router-link :to="gradeRoute(grade, 'lesson')" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-video"></i>
        <span>الدروس</span>
      </router-link>
      <router-link :to="gradeRoute(grade, 'content')" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-folder-open"></i>
        <span>المحتوى</span>
      </router-link>
      <router-link :to="gradeRoute(grade, 'questions')" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-question-circle"></i>
        <span>بنك الأسئلة</span>
      </router-link>
      <router-link :to="gradeRoute(grade, 'exams')" class="module-link" @click="$emit('link-click')">
        <i class="pi pi-file-edit"></i>
        <span>الامتحانات</span>
      </router-link>
    </div>

    <div class="module-card__footer">
      <div class="module-sms-trigger">
        <BulkSms v-if="grade.id" :academic_year_id="grade.id" />
        <WhatsAppGroupSend />
      </div>
    </div>
  </div>
</template>

<script>
import BulkSms from '@/components/reservation/BulkSms.vue';
import WhatsAppGroupSend from '@/components/reservation/WhatsAppGroupSend.vue';

export default {
  name: 'GradeCard',
  components: { BulkSms, WhatsAppGroupSend },
  props: {
    grade: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      default: 'module-card--blue',
    },
    gradeRoute: {
      type: Function,
      required: true,
    },
  },
  emits: ['link-click'],
};
</script>
